import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterPipe } from 'src/app/services/filter.pipe';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import {MatSelectModule} from '@angular/material/select';


import { OptionalItemsRoutingModule } from './optional-items-routing.module';
import { OptionalItemsComponent } from './optional-items.component';
import { OptionalItemsListComponent } from './optional-items-list/optional-items-list.component';
import { OptionalItemAddEditComponent } from './optional-item-add-edit/optional-item-add-edit.component';
import { OptionalItemDetailsComponent } from './optional-item-details/optional-item-details.component';
import { AssignItemListComponent } from './assign-item-list/assign-item-list.component';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';

@NgModule({
  declarations: [
    OptionalItemsComponent,
    OptionalItemsListComponent,
    OptionalItemAddEditComponent,
    OptionalItemDetailsComponent,
    AssignItemListComponent,
    FilterPipe
  ],
  imports: [
    CommonModule,
    OptionalItemsRoutingModule,
    FurySharedModule,
    ListModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    FlexLayoutModule,
    MatIconModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatSelectModule,
    FuryCardModule
  ]
})
export class OptionalItemsModule { }
